var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"parts-layout row",style:(_vm.layoutStyle)},_vm._l((_vm.parts),function(part){return _c('div',{key:part.id,staticClass:"part col-12",style:({
              top: part.rowidx * _vm.height + 'px',
              left: part.colidx * _vm.width + 'px',
              width: part.colcnt * _vm.width + 'px',
              height: part.rowcnt * _vm.height + 'px',
          })},[(!part.available)?_c(part.component,_vm._b({tag:"component",attrs:{"webpart":part}},'component',part.props,false)):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }